module.exports = __webpack_public_path__ + "static/media/T23.48229d21.jpg";